<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <span>پیش نمایش پیامک</span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<div mat-dialog-content class="matDialogContent" style="padding: 1.5rem 1rem !important">
    <div class="row right padding0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 padding0">
            گیرنده پیامک : {{ user_cellphone }} / {{ user_title }}
        </div>
    </div>
    <div class="row textBox">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text right" style="padding: 0.5rem 0.5rem;">
            فاکتور خرید شما در
            {{ store_title }}
            صادر شد.
            <br>
            مشاهده فاکتور آنلاین:
            <br>
            <a href="{{ Link }}" target="_blank">
                لینک
            </a>
        </div>
    </div>
</div>

<div mat-dialog-actions class="pe1 matDialogActions">
    <button type="button" class="btn_pe" style="min-width: 6rem;" (click)="check_charge_sms()" [disabled]="loading">
        <span [hidden]="loading">
            ارسال پیامک
        </span>
        <span [hidden]="!loading">
            <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status">
            </div>
        </span>
    </button>
</div><!-- row -->